import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
  icon?: boolean;
}
export function Button({
  variant = 'primary',
  children,
  icon,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'relative px-8 py-4 rounded-full font-medium transition-all duration-300 flex items-center justify-center gap-2 overflow-hidden group';
  const variants = {
    primary: 'bg-white text-deep-dark hover:bg-neon-cyan hover:text-deep-dark shadow-[0_0_20px_rgba(0,217,255,0.3)] hover:shadow-[0_0_30px_rgba(0,217,255,0.6)]',
    secondary: 'bg-transparent border border-white/20 text-white hover:border-electric-violet hover:text-electric-violet hover:shadow-[0_0_20px_rgba(139,92,246,0.3)]'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-106">
      <span className="relative z-10 flex items-center gap-2" data-id="element-107">
        {children}
        {icon && <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-108" />}
      </span>
    </motion.button>;
}